import { useState } from 'react'
import { VisualZoom } from 'app/frontend/types/custom/VisualPlan'

const zoomKey = (zoom: VisualZoom | undefined) =>
  zoom ? `${zoom.scale}:${zoom.x}:${zoom.y}` : ''

export const useViewZoom = (savedZoom: VisualZoom | undefined) => {
  const savedKey = zoomKey(savedZoom)
  const [override, setOverride] = useState<{
    key: string
    zoom: VisualZoom | undefined
  } | null>(null)

  const viewZoom = override?.key === savedKey ? override.zoom : savedZoom

  const setViewZoom = (next: VisualZoom | undefined) => {
    setOverride({
      key: savedKey,
      zoom: next && next.scale > 1 ? next : undefined,
    })
  }

  return [viewZoom, setViewZoom] as const
}
